import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import menuReducer from './slice/sidebarSlice';
import lovReducer from './slice/lovSlice';
import loadingReducer from './slice/loadingSlice';
import locationReducer from './slice/locationSlice';
import personelReducer from './slice/personelSlice';
import categoryReducer from './slice/categorySlice';
import jobReducer from './slice/jobSlice';
import authReducer from './slice/authSlice';
import localForage from 'localforage';      

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['menu', 'lov', 'personel','loading','category','job','auth'],
};

const locationPersistConfig = {
  key: 'location',
  storage: localForage, 
};

const rootReducer = combineReducers({
  menu: menuReducer,
  lov: lovReducer,
  personel: personelReducer,
  category: categoryReducer,
  loading: loadingReducer,
  job: jobReducer,
  auth: authReducer,
  location: persistReducer(locationPersistConfig, locationReducer),
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;